import { FilterBody } from "./FilterBody";
import { FilterFooter } from "./FilterFooter";
import { FilterHeader } from "./FilterHeader";

export const FilterContent = {
  Header: FilterHeader,
  Body: FilterBody,
  Footer: FilterFooter,
};
